



























































import {Component, Prop, Vue} from 'vue-property-decorator'
import IconCustom from '@/components/lib/IconCustom.vue'
import InputRange from '@/components/lib/InputRange.vue'
import CheckboxCommon from '@/components/lib/CheckboxCommon.vue'
import {
  IFilter
} from '@/components/lib/models';

@Component({
  components: {
    IconCustom,
    InputRange,
    CheckboxCommon,
  }
})
export default class TravelCriterionFilter extends Vue {
  @Prop() readonly data?: IFilter

  private expanded: boolean = false;

  mounted() {
    this.$store.dispatch('setCheckboxLabelColor', false);
  }

  get bodyOverflow(): string {
    return 'overflow-' + (this.expanded ? 'visible' : 'hidden');
  }

  private toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  get title(): string {
    let title = this.$t('filter.criteria.' + this.data?.label) as string;
    return title + (this.data?.label === 'duration_days' ? `, ${this.$tc('days', 10)}` : '');
  }

  get haveChoice(): boolean {
    return this.data?.type === 'range' || !!this.data?.items?.length;
  }

  get iconColor(): string {
    return this.data?.selected ? 'accent' : 'ui-gray';
  }

}
